import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon/Icon';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link';

import { actions as bottomDrawerActions } from 'features/bottomDrawers/slice';
import { usePredictedFundingFailureData } from 'features/payroll/components/Alerts/PredictedFundingFailureAlert/usePredictedFundingFailureData';
import {
  PAYROLL_DRAWER_COMPONENTS_NAMES,
  PAYROLL_TRACKING,
} from 'features/payroll/constants';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';
import { trackUxEvent } from 'util/tracking';
import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';

const { cx } = cxHelpers('PredictedFundingFailureBanner');

const { PAYROLL_PREDICTED_FUNDING_FAILURE_DRAWER } =
  PAYROLL_DRAWER_COMPONENTS_NAMES;

const I18N_KEY = 'payroll.dashboard.alert.funding_failure_requirement';
const REQUIREMENT_STATUS_RESOLVED = 'resolved';

const PredictedFundingFailureBanner = () => {
  const dispatch = useDispatch();
  const {
    predictedFundingFailureRequirement,
    predictedFailurePaydayChanged,
    predictedFailureWireIntention,
  } = usePredictedFundingFailureData();

  const linkText = toI18n(`${I18N_KEY}.cta`);

  const handleOpenPredictedFundingFailureDrawer = useCallback(() => {
    trackUxEvent({
      productArea: PAYROLL_TRACKING['payroll.productArea'],
      eventCategory:
        PAYROLL_TRACKING['payroll.event_category.nsf_prediction_resolution'],
      eventAction: EVENT_ACTIONS.LINK_CLICKED,
      actionType: TRACK_ACTION_TYPES.CLICK,
      properties: {
        link_text: linkText,
      },
    });
    dispatch(
      bottomDrawerActions.openBottomDrawer({
        drawerType: PAYROLL_PREDICTED_FUNDING_FAILURE_DRAWER,
        choseWireOption: predictedFailureWireIntention,
      })
    );
  }, [linkText, dispatch, predictedFailureWireIntention]);

  const resolved =
    predictedFundingFailureRequirement?.get('requirementStatus') ===
    REQUIREMENT_STATUS_RESOLVED;

  const shouldHideBanner =
    !predictedFundingFailureRequirement ||
    resolved ||
    predictedFailureWireIntention ||
    predictedFailurePaydayChanged;

  if (shouldHideBanner) {
    return null;
  }

  return (
    <Box h={36} className={cx()} bgcolor="red100" vcenter hcenter>
      <Box row vcenter hcenter>
        <Icon size="small" iconName="Critical" color="error300" mr={8} />
        <Box mr={8}>
          <Text
            color="mono900"
            variant="bodySmBoldTight"
            i18n={`${I18N_KEY}.text`}
          />
        </Box>
        <Box mr={8}>
          <Text
            color="mono900"
            variant="bodySmTight"
            i18n={`${I18N_KEY}.body`}
          />
        </Box>
        <Box mb={6}>
          <Link size="small" onClick={handleOpenPredictedFundingFailureDrawer}>
            {linkText}
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default PredictedFundingFailureBanner;
